import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Modal, Button } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Link } from 'react-router-dom';
import SelectedModel from './selectedModel';

const Edittask = ({ showModal, handleClose }) => {
  const [showModals, setShowModals] = useState(false);
  const navigate = useNavigate();

  const handleClosed = () => setShowModals(false);
  const handleShows = () => setShowModals(true);

  const handleConfirm = () => {
    handleClosed();
    navigate('/path/to/Select Task'); // Redirect or handle as needed
  };

  return (
    <div>
      <Modal show={showModal} onHide={handleClose} dialogClassName="modal-90w" size="lg">
        <Modal.Header closeButton style={{ backgroundColor: '#004aad' }}>
          <Modal.Title className='heading' style={{ color: 'white', fontSize: "20px" }}>Procedure Task</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <b>Case Start </b>
          <span
            onClick={handleShows}
            style={{ color: '#004aad', marginLeft: '210px', textDecoration: "none", cursor: 'pointer' }}
          >
            Select Task
          </span>
          <br />
          <strong>PRV MULTILAYERED ZIRCONIA </strong>
          <Link to="/path/to/Select Task" style={{ color: '#004aad', marginLeft: '50px', textDecoration: "none" }}>
            7 Tasks Selected
          </Link>
          <br />
          <strong>CROWN</strong>
          <Link to="/path/to/1 Select Task" style={{ color: '#004aad', marginLeft: '226px', textDecoration: "none" }}>
            1 Tasks Selected
          </Link>
          <br />
          <strong>Step 1 End</strong>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={handleClose}
            style={{ backgroundColor: '#004aad', borderColor: '#004aad', marginLeft: "160px" }}
          >
            Cancel
          </Button>
          <Button
            variant="secondary"
            onClick={handleClose}
            style={{ backgroundColor: '#004aad', borderColor: '#004aad', marginLeft: "1px" }}
          >
            Reschedule Tasks
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Add the Selectedmodel component here */}
      <SelectedModel
        show={showModals}
        handleClose={handleClosed}
        handleConfirm={handleConfirm}
      />
    </div>
  );
};

export default Edittask;
